import * as React from "react";
import { Container, Grid, Paper } from "@material-ui/core";
import { useState } from "react";
import { useAuth, useVerifyPermission } from "@airborne/react-admin";
import PrematureFailureList from "./PrematureFailureList";
import PrematureFailureTrend from "./PrematureFailureTrend";
import PrematureFailureRateSource from "./PrematureFailureRateSource";
import PrematureFailureFilter from "./PrematureFailureFilter";

const PrematureFailure = props => {
  useVerifyPermission("customroutes", "prematurefailure.read");
  const { user } = useAuth();

  const now = new Date();
  const [filterParams, setFilterParams] = useState({
    ownerCode: user?.isCustomer ? [user?.ownerCode] : [],
    startDate: new Date(new Date().setMonth(now.getMonth() - 1)),
    endDate: now,
  });

  const CreateFilter = filterParams => {
    var filter = {
      createdDate__gte: filterParams.startDate,
      createdDate__lte: filterParams.endDate,
    };

    if (!user?.isCustomer && filterParams?.ownerCode?.length > 0) {
      let ownerCodeFilter =
        filterParams?.ownerCode?.length === 1
          ? { ownerCode__eq: filterParams.ownerCode?.[0] }
          : { ownerCode__in: filterParams.ownerCode };

      filter = Object.assign(ownerCodeFilter, filter);
    }
    if (filterParams?.fleetType) {
      filter = { ...filter, ...{ fleetType__eq: filterParams?.fleetType } };
    }
    if (filterParams?.acType) {
      filter = { ...filter, ...{ acType__eq: filterParams?.acType } };
    }

    return filter;
  };

  return (
    <>
      <PrematureFailureFilter filterParams={filterParams} setFilterParams={setFilterParams} />
      <br />
      <Container maxWidth="xl">
        <Paper variant="outlined">
          <Grid container direction="row" justifyContent="center" alignItems="center">
            <Grid item>
              <PrematureFailureTrend filterParams={CreateFilter(filterParams)} />
            </Grid>
          </Grid>
        </Paper>
      </Container>
      <Container maxWidth="xl">
        <Paper variant="outlined">
          <PrematureFailureRateSource filterParams={CreateFilter(filterParams)} />
        </Paper>
      </Container>
      <br />
      <Container maxWidth="xl">
        <Paper elevation={2} variant="outlined">
          <PrematureFailureList
            basePath="reliabilityprematurefailures"
            filterParams={CreateFilter(filterParams)}
            {...props}
          />
        </Paper>
      </Container>
    </>
  );
};

export default PrematureFailure;
